import React, { useContext } from "react";
import { RecordsManagementContext } from "../StatesMangement/InitialiseContext";

// Shared styling so all slot inputs align neatly and stay compact
const commonInputStyle = {
  width: "100px",
  textAlign: "center",
  backgroundColor: "#e9ecef",
  border: "1px solid #ced4da",
  borderRadius: "4px",
  padding: "4px 6px",
  height: "32px",
};

export default () => {
  const IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails;
    return (
        <div className=" d-flex moving_charges">
      <div className="row moving_charges_row" style={{ gap: "6px" }}>
        <div className="col start_end_col" style={{ display: "flex", gap: "8px" }}>
          <HoursType record={IV1_PageDetails.StartEndTime} />
          <StartEndTime heading="START TIME" record={IV1_PageDetails.StartEndTime} type="Start" />
          <StartEndTime heading="END TIME" record={IV1_PageDetails.StartEndTime} type="End" />
          <HourlyRate heading="HOURLY RATE" record={IV1_PageDetails.StartEndTime} />
          <SlotDiscountTime heading={"DISCOUNT TIME"} record={IV1_PageDetails.StartEndTime}/>
          <JobDate record={IV1_PageDetails.StartEndTime} />
                </div>
            </div>
      <div className="col moving_charges_col">
        <p className="charge_text">MEAL TIME ALLOWANCE OR TIME LOST DUE TO WEATHER CONDITIONS</p>
            </div>
      {IV1_PageDetails.DigitalInvoicePagePricingData ? (
                <>
            <div className="col">
            <DiscountOrChargedTime
              chargeType="TOTAL CHARGED TIME"
              value={IV1_PageDetails.DigitalInvoicePagePricingData.TotalChargeTime}
            />
            </div>
        </>
      ) : null}
        </div>
  );
};

const HoursType = ({ record }) => (
  <div className="col">
    <p className="charge_text" style={{ textAlign: "center" }}>
      <b>HOURS TYPE</b>
    </p>
    {record.map((time, key) => (
      <input
        type="text"
        className="form-control input_field"
        key={`${key}-hours-type`}
        placeholder={time.HoursType}
        disabled
        style={commonInputStyle}
      />
    ))}
  </div>
);

const JobDate = ({ record = [] }) => {
  const getDateValue = (time) => {
    if (!time) return "";
    if (time.Date) return time.Date;
    return "";
  };

    return (
        <div className="col">
      <p className="charge_text" style={{ textAlign: "center" }}>
        <b>DATE</b>
      </p>
      {record.map((time, key) => (
        <input
          type="text"
          className="form-control input_field"
          key={`${key}-jobDate`}
          value={getDateValue(time)}
          disabled
          style={commonInputStyle}
        />
      ))}
        </div>
  );
};

const HourlyRate = ({ record, heading }) => {
  if (!Array.isArray(record)) return null;

    const getType = (t) => {
    const type = t.HoursType != null ? t.HoursType : t.HourType != null ? t.HourType : "";
        return type.trim();
    };

  const formatRate = (val) => {
    if (val === undefined || val === null || val === "") return "";
    const num = Number(val);
    if (!isNaN(num)) {
      return Number.isInteger(num) ? num.toFixed(0) : num.toFixed(2);
    }
    return val;
  };

    return (
        <div className="col">
      <p className="charge_text" style={{ textAlign: "center" }}>
        <b>{heading || "HOURLY RATE"}</b>
      </p>

            {record.map((time, key) => {
                const hoursType = getType(time);
                const isPacking = /^packing$/i.test(hoursType);
        const rateValue = time.HourlyRate != null ? time.HourlyRate : "";

                if (isPacking) {
                    return (
                        <input
                            type="text"
                            className="form-control input_field"
              key={`${key}-hourlyRatePacking`}
                            value=""
                            disabled
              style={{ ...commonInputStyle, visibility: "hidden" }}
                        />
                    );
                }

                return (
                    <input
                        type="text"
                        className="form-control input_field"
            key={`${key}-hourlyRate`}
            value={formatRate(rateValue)}
                        disabled
            style={commonInputStyle}
                    />
                );
            })}
        </div>
    );
};

const SlotDiscountTime = ({ heading, record = [] }) => (
  <div className="col discount_time_col">
    <p className="charge_text" style={{ textAlign: "center", whiteSpace: "nowrap" }}>
      <b>{heading}</b>
    </p>
    {record.map((time, key) => (
      <input
        type="text"
        className="form-control input_field"
        key={`${key}-discount-time`}
        value={time && time.DiscountTime != null ? time.DiscountTime : ""}
        disabled
      />
    ))}
  </div>
);

const StartEndTime = ({ heading, record, type }) => (
            <div className="col">
    <p className="charge_text" style={{ textAlign: "center" }}>
      <b>{heading}</b>
    </p>
    {record.map((time, key) => (
      <input
        type="text"
        className="form-control input_field"
        key={`${key}-${type}`}
        placeholder={type === "Start" ? time.StartTime : time.EndTime}
        disabled
        style={commonInputStyle}
      />
    ))}
            </div>
);

const DiscountOrChargedTime = ({ chargeType, value }) => (
        <>
    <p className="charge_text">
      <b>{chargeType}</b>
    </p>
    <input type="text" className="form-control input_field_2" placeholder={value} disabled />
        </>
);
